import React, { Component, useEffect, useState } from 'react';
import API_URL from '../../ApiUrl';
import axios from 'axios';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import Moment from 'moment';
import './scholarship.css';

const Scholarship = () => {

    const [dataScholarship, setDataScholarship] = useState([]);
    const [dataJenjang, setDataJenjang] = useState([]);
    const [dataNegara, setDataNegara] = useState([]);
    const [dataTipeDana, setDataTipeDana] = useState([]);
    const [dataUniversities, setDataUniversities] = useState([]);
    const [modal, setModal] = useState(false);
    const [description, setDescription] = useState('');
    const [university, setUniversity] = useState([]);
    const [country, setCountry] = useState([]);
    const [tipeFinance, setTipeFinance] = useState([]);
    const [program, setProgram] = useState([]);
    // const [sortFilter, setSortFilter] = useState('Terdekat');
    const [checkedFilters, setCheckedFilters] = useState({});

    const getScholarship = async () => {
        try {
            const res = await axios.get(`${API_URL.superStudent}/website/scholarship`);
            setDataScholarship(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    const getFilterJenjang = async () => {
        try {
            const res = await axios.get(`${API_URL.superStudent}/filter/jenjang`);
            setDataJenjang(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    const getFilterNegara = async () => {
        try {
            const res = await axios.get(`${API_URL.superStudent}/filter/negara`);
            setDataNegara(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    const getFilterTipeDana = async () => {
        try {
            const res = await axios.get(`${API_URL.superStudent}/filter/tipe`);
            setDataTipeDana(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };


    const getFilterUniversities = async () => {
        try {
            const res = await axios.get(`${API_URL.superStudent}/filter/universities`);
            setDataUniversities(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    const getScholarshipByFilter = async () => {
        try {
            const res = await axios.get(
                `${API_URL.superStudent}/filter/scholarship`,
                {
                    params: {
                        university: JSON.stringify(university),
                        country: JSON.stringify(country),
                        tipe: JSON.stringify(tipeFinance),
                        program: JSON.stringify(program)
                    }
                }
            );

            setDataScholarship(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    const clearFilters = () => {
        setUniversity([]);
        setCountry([]);
        setTipeFinance([]);
        setProgram([]);
        setCheckedFilters({});
        getScholarship();
    };

    const closeDialog = () => {
        setModal(false);
    };

    const detailDesc = (e) => {
        setModal(true);
        setDescription(e);
    }

    const modalDetail = () => {
        return (
            <div className="card-body btn-showcase">
                <Modal isOpen={modal} toggle={() => closeDialog()}>
                    <ModalHeader toggle={closeDialog}>Description</ModalHeader>
                    <ModalBody>
                        <p>{stripHtml(description || 'Tidak ada deskripsi')}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={closeDialog}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    const toggleFilterValue = (currentValues, value, isChecked) => {
        if (isChecked) {
            return [...currentValues, value];
        }
        return currentValues.filter((v) => v !== value);
    };

    const filterUniversity = (e) => {
        const { value, checked, id } = e.target;
        setCheckedFilters((prev) => ({ ...prev, [id]: checked }));
        setUniversity((prev) => toggleFilterValue(prev, value, checked));
    };

    const filterCountry = (e) => {
        const { value, checked, id } = e.target;
        setCheckedFilters((prev) => ({ ...prev, [id]: checked }));
        setCountry((prev) => toggleFilterValue(prev, value, checked));
    };

    const filterTipeFinance = (e) => {
        const { value, checked, id } = e.target;
        setCheckedFilters((prev) => ({ ...prev, [id]: checked }));
        setTipeFinance((prev) => toggleFilterValue(prev, value, checked));
    };

    const filterProgram = (e) => {
        const { value, checked, id } = e.target;
        setCheckedFilters((prev) => ({ ...prev, [id]: checked }));
        setProgram((prev) => toggleFilterValue(prev, value, checked));
    };

    useEffect(() => {
        getScholarship();
        getFilterJenjang();
        getFilterNegara();
        getFilterTipeDana();
        getFilterUniversities();
    }, []);

    const stripHtml = (html) => {
        if (!html) return '';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    };

    return (
        <div className="scholarship-page">
            {/* Hero Section */}
            <section className='scholarship-hero' style={{ backgroundImage: "url('/assets/scholarship/hero_banner.png')" }}>
                <div className="scholarship-hero-overlay"></div>
                <div className='container'>
                    <div className="scholarship-hero-content">
                        <div className="hero-badge">
                            <i className="bi bi-mortarboard-fill"></i> GERBANG PELUANG AKADEMIK
                        </div>
                        <h1 className="hero-title">
                            Temukan <br />
                            <span className="highlight">Beasiswa</span> Impianmu
                        </h1>
                        <p className="hero-subtitle">
                            Eksplorasi ribuan peluang pendidikan dari universitas ternama dunia dengan kurasi data terlengkap dan dukungan pendanaan eksklusif.
                        </p>
                        <div className="hero-actions">
                            <button className="btn-hero-primary" onClick={() => window.scrollTo({ top: 600, behavior: 'smooth' })}>
                                Mulai Pencarian <i className="bi bi-arrow-right"></i>
                            </button>
                            <button className="btn-hero-secondary">
                                Jelajahi
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <section className="scholarship-main">
                <div className="bg-blob-1"></div>
                <div className="bg-blob-2"></div>
                <div className="bg-blob-3"></div>

                <div className='container'>
                    <Row>
                        {/* Sidebar Filter */}
                        <Col lg='3' md='4' sm='12' className='mb-5'>
                            <div className="filter-sidebar">
                                <div className="filter-header">
                                    <h4>Filter</h4>
                                    <p>Temukan beasiswa yang paling relevan dengan profil Anda.</p>
                                </div>

                                <Accordion allowZeroExpanded className="filter-accordion">
                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <i className="bi bi-bank text-danger"></i> Universitas
                                                </div>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <div className="filter-search-box">
                                                <i className="bi bi-search"></i>
                                                <input type="text" className="filter-search-input" placeholder="Cari kampus..." />
                                            </div>
                                            <div className="filter-checkbox-list">
                                                {dataUniversities.slice(0, 5).map((detail, i) => (
                                                    <div className="checkbox-item" key={i}>
                                                        <input
                                                            type="checkbox"
                                                            name='university'
                                                            id={`univ-${i}`}
                                                            value={detail.code_school_rep}
                                                            checked={!!checkedFilters[`univ-${i}`]}
                                                            onChange={filterUniversity} />
                                                        <label htmlFor={`univ-${i}`}>{detail.universities != null ? detail.universities.nama_sekolah : 'Others'}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionItemPanel>
                                    </AccordionItem>

                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <i className="bi bi-globe text-danger"></i> Negara
                                                </div>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <div className="filter-checkbox-list">
                                                {dataNegara.map((detail, i) => (
                                                    <div className="checkbox-item" key={i}>
                                                        <input type="checkbox"
                                                            name='country'
                                                            id={`country-${i}`}
                                                            value={detail.country.countrycode}
                                                            checked={!!checkedFilters[`country-${i}`]}
                                                            onChange={filterCountry} />
                                                        <label htmlFor={`country-${i}`}>{detail.country.countryname}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionItemPanel>
                                    </AccordionItem>

                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <i className="bi bi-cash-stack text-danger"></i> Tipe Pendanaan
                                                </div>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <div className="filter-checkbox-list">
                                                {dataTipeDana.map((detail, i) => (
                                                    <div className="checkbox-item" key={i}>
                                                        <input
                                                            type="checkbox"
                                                            name='tipe_finance'
                                                            id={`fund-${i}`}
                                                            value={detail.scholarship_type}
                                                            checked={!!checkedFilters[`fund-${i}`]}
                                                            onChange={filterTipeFinance} />
                                                        <label htmlFor={`fund-${i}`}>{detail.scholarship_type == 1 ? 'Fully Funded' : 'Partially Funded'}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionItemPanel>
                                    </AccordionItem>

                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <i className="bi bi-award text-danger"></i> Jenjang Program
                                                </div>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <div className="filter-checkbox-list">
                                                {['Certificate 3', 'Certificate 4', 'Diploma', 'Advanced Diploma', 'Bachelor', 'Master', 'Ph.D'].map((prog, i) => (
                                                    <div className="checkbox-item" key={i}>
                                                        <input type="checkbox" id={`prog-${i}`} name='program' value={prog} checked={!!checkedFilters[`prog-${i}`]} onChange={filterProgram} />
                                                        <label htmlFor={`prog-${i}`}>{prog}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                </Accordion>

                                <button className="btn-apply-filter" onClick={getScholarshipByFilter}>
                                    Terapkan Filter
                                </button>
                                <button className="btn-clear-filter" onClick={clearFilters}>
                                    HAPUS SEMUA FILTER
                                </button>
                            </div>
                        </Col>

                        {/* Scholarship List */}
                        <Col lg='9' md='8' sm='12'>
                            <div className="scholarship-grid-header">
                                <div className="grid-title">
                                    <h3>Daftar Beasiswa Terbaru</h3>
                                    <p>Menampilkan {dataScholarship.length} peluang beasiswa yang aktif</p>
                                </div>
                                {/* <div className="sort-options">
                                    <span className="sort-label">Urutkan:</span>
                                    <button className={`sort-btn ${sortFilter === 'Terdekat' ? 'active' : ''}`} onClick={() => setSortFilter('Terdekat')}>Terdekat</button>
                                    <button className={`sort-btn ${sortFilter === 'Terpopuler' ? 'active' : ''}`} onClick={() => setSortFilter('Terpopuler')}>Terpopuler</button>
                                </div> */}
                            </div>

                            <Row>
                                {dataScholarship.map((detail, i) => {
                                    // Randomly assign placeholder images for a better visual as in the design
                                    const placeholders = [
                                        '/assets/img/slide/scholarship/scholarship.jpg',
                                        'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
                                        'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
                                        'https://images.unsplash.com/photo-1658235081452-c2ded30b8d9f?q=80&w=1114&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
                                    ];
                                    const randImg = placeholders[i % placeholders.length];

                                    // Format jenjang logic based on API data
                                    let jenjangStr = "Master, PhD";
                                    if (detail.program && detail.program.length > 0) {
                                        jenjangStr = detail.program.map(p => p.program).join(', ');
                                        if (jenjangStr.length > 20) jenjangStr = jenjangStr.substring(0, 20) + '...';
                                    }

                                    return (
                                        <Col lg='6' md='12' className="mb-4" key={i}>
                                            <div className="scholarship-card">
                                                <div className="card-img-container">
                                                    <span className="country-tag">{detail.country?.countryname || 'GLOBAL'}</span>
                                                    <img src={randImg} alt="University" />
                                                </div>
                                                <div className="card-body-content">
                                                    <h4 className="card-scholarship-title">{detail.scholarship_name}</h4>
                                                    <div className="card-university">
                                                        <i className="bi bi-patch-check-fill text-primary"></i>
                                                        {detail.universities != null ? detail.universities.nama_sekolah : 'VARIOUS UNIVERSITIES'}
                                                    </div>

                                                    <div className="card-specs">
                                                        <div className="spec-item">
                                                            <span className="spec-label">STATUS</span>
                                                            <span className="spec-val">{detail.scholarship_type == 1 ? 'Fully Funded' : 'Partially Funded'}</span>
                                                        </div>
                                                        <div className="spec-item">
                                                            <span className="spec-label">JENJANG</span>
                                                            <span className="spec-val">{jenjangStr}</span>
                                                        </div>
                                                    </div>

                                                    <div className="card-dates">
                                                        <div className="date-item">
                                                            <i className="bi bi-calendar-event"></i> Buka: {Moment(detail.open_reg).local().format("D MMM YYYY")}
                                                        </div>
                                                        <div className="date-item deadline">
                                                            <i className="bi bi-alarm"></i> Deadline: {Moment(detail.close_reg).local().format("D MMM YYYY")}
                                                        </div>
                                                    </div>

                                                    <button className="btn-card-action" onClick={() => detailDesc(detail.description || 'Tidak ada deskripsi.')}>
                                                        Lihat Detail
                                                    </button>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })}
                            </Row>

                            {/* {dataScholarship.length > 0 && (
                                <button className="btn-load-more">
                                    Tampilkan Lebih Banyak Beasiswa <i className="bi bi-arrow-down"></i>
                                </button>
                            )} */}
                        </Col>
                    </Row>
                </div>
            </section>
            {modalDetail()}
        </div>
    )
}

export default Scholarship;